import { motion } from "framer-motion";
import { FadeUp, Chapter, EASE } from "@/components/Reveal";
import { WHY_US } from "@/data/content";

const slug = (t) => t.toLowerCase().replace(/[^a-z]+/g, "-");

export default function WhyUs() {
  return (
    <section
      data-testid="why-us-section"
      className="border-t border-white/5 py-28 lg:py-36"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Chapter num="03" label="Why Choose Us" center />
        <FadeUp delay={0.1}>
          <h2 className="mx-auto mt-8 max-w-2xl text-center font-serif text-4xl leading-tight tracking-[-0.02em] text-cream sm:text-5xl">
            An Agency That Treats Your Budget Like{" "}
            <span className="italic text-gold">Its Own.</span>
          </h2>
        </FadeUp>

        <div className="mt-16 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {WHY_US.map((w, i) => (
            <motion.div
              key={w.title}
              data-testid={`why-card-${slug(w.title)}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.1, ease: EASE }}
              whileHover={{ y: -6 }}
              className="rounded-2xl border border-white/10 p-8 transition-colors duration-500 hover:border-gold/40"
            >
              <span className="font-serif text-sm italic text-gold/60">
                0{i + 1}
              </span>
              <w.icon className="mt-5 h-6 w-6 text-gold" />
              <h3 className="mt-5 font-serif text-xl text-cream">{w.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-cream/50">
                {w.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
